export const initialValues = {
  applicantInformation: {
    fullName: '',
    contactEmail: '',
  },
  step1: {
    section1: {
      name: '',
      dob: '',
      race: '',
      phone: '',
      email: '',
      clientType: '',
    },
    section2: {
      streetAddress: '',
      city: '',
      state: '',
      zipCode: '',
      rentStatus: '',
      lengthInYears: '',
      codeViolation: '',
    },
    section3: {
      propertyTaxes: '',
      waterBills: '',
      sewageBills: '',
      refuseBills: '',
    },
    section4: {
      ownedProperties: [],
    },
    section5: {
      q1: '',
      projectFinancialReadiness: '',
      understandProcess: '',
    },
    section6: {
      financialReadiness: '',
      communitySupport: '',
    },
  },
  step2: {
    q1: '',
    q2: '',
    interestedProperties: [],
    'q1-interestedPropertyDetail': '',
  },
};
